import {Backend} from '@common/backend'
import {globals} from '@extensions/globals-base'

type RetType = {
  status?: boolean
}

export const trackDownload = async (url: string): Promise<RetType> => {
  const companyId = globals.getCompanyId()

  const resp = await Backend.postJSON<RetType>(
    '/data/unsplash/track-download',
    {
      ...Backend.loadCred(),
      companyId,
      url
    }
  )

  return resp
}
